import { render } from "./LoginForm.vue?vue&type=template&id=a6d20730&scoped=true&ts=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=a6d20730&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d20730"]])

export default __exports__